import { useTranslation } from "react-i18next"

import type { SubscriptionStatusEnum } from "@/enums/subscriptions"

import { Badge } from "../ui/badge"
import { getSubscriptionMainStatusInfo } from "./SubscriptionsHelper"

interface SubscriptionsStatusBadgeProps {
  status: SubscriptionStatusEnum | string
}

export const SubscriptionsStatusBadge = ({
  status,
}: SubscriptionsStatusBadgeProps) => {
  const { t } = useTranslation()
  const { label, bgColor } = getSubscriptionMainStatusInfo(
    status as SubscriptionStatusEnum,
    t
  )

  return (
    <Badge
      variant="none"
      className="flex h-fit items-center justify-start gap-1 rounded-full"
    >
      <div
        className="rounded-full px-2 py-1 text-white"
        style={{ backgroundColor: bgColor }}
      >
        {label}
      </div>
    </Badge>
  )
}
